import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import HistorySection from "./components/HistorySection";
import VisionSection from "./components/VisionSection";
import ProductsSection from "./components/ProductsSection";
import SolutionsSection from "./components/SolutionsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <main className="bg-[#020b18] min-h-screen font-sans">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <HistorySection />
      <VisionSection />
      <ProductsSection />
      <SolutionsSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
